import { Phone, Mail, MapPin } from "lucide-react";
import { scrollToId, BRAND } from "@/lib/scroll";

const QUICK = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why-us" },
  { label: "Expertise", id: "expertise" },
  { label: "Skillbuddy", id: "skillbuddy", page: "/skillbuddy" },
  { label: "PitchPrep", id: "pitchprep", page: "/pitchprep" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-nexblue text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
        <div>
          <div className="inline-flex items-center rounded-2xl bg-white px-5 py-3 shadow-[0_4px_20px_rgba(0,0,0,0.25)]" data-testid="brand-logo-footer">
            <img src="/assets/nexorbit-lockup.png" alt="NexOrbit Solutions LLP" className="h-10 w-auto" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/60">
            Veteran-led cloud infrastructure and management for startups and mid-enterprises.
          </p>
          <p className="mt-4 text-[11px] font-semibold tracking-[0.3em] text-nexcyan">
            INNOVATE | EMPOWER | ELEVATE
          </p>
          <div className="mt-6 flex flex-wrap gap-2" data-testid="footer-sub-brands">
            <a
              href="/skillbuddy"
              data-testid="footer-skillbuddy-badge"
              className="rounded-full border border-nexorange/40 bg-nexorange/10 px-3 py-1.5 text-[10px] font-bold tracking-[0.2em] text-nexorange transition-colors duration-300 hover:bg-nexorange/25"
            >
              AI EDTECH PRODUCTS
            </a>
            <span className="rounded-full border border-nexcyan/40 bg-nexcyan/10 px-3 py-1.5 text-[10px] font-bold tracking-[0.2em] text-nexcyan">CLOUD INFRA SOLUTIONS</span>
          </div>
          <a
            href="https://www.skillbuddy.net"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-skillbuddy-link"
            className="mt-3 inline-block text-xs font-semibold text-white/60 transition-colors duration-200 hover:text-nexorange"
          >
            Skillbuddy — AI life-skills companion (pilot) ↗
          </a>
          <a
            href="https://www.pitchprep.co.in"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-pitchprep-link"
            className="mt-2 inline-block text-xs font-semibold text-white/60 transition-colors duration-200 hover:text-nexorange"
          >
            PitchPrep — Investor pitch practice (pilot) ↗
          </a>
        </div>

        <nav aria-label="Quick links">
          <h4 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white/50">Quick Links</h4>
          <ul className="mt-5 space-y-3">
            {QUICK.map((q) => (
              <li key={q.id}>
                {q.page ? (
                  <a
                    href={q.page}
                    data-testid={`footer-link-${q.id}`}
                    className="text-sm text-white/70 transition-colors duration-200 hover:text-nexcyan"
                  >
                    {q.label}
                  </a>
                ) : (
                  <button
                    onClick={() => scrollToId(`#${q.id}`)}
                    data-testid={`footer-link-${q.id}`}
                    className="text-sm text-white/70 transition-colors duration-200 hover:text-nexcyan"
                  >
                    {q.label}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white/50">Connect With Us</h4>
          <ul className="mt-5 space-y-4 text-sm text-white/70">
            <li>
              <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors duration-200 hover:text-nexcyan">
                <Phone size={15} className="text-nexcyan shrink-0" /> {BRAND.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="flex items-center gap-3 transition-colors duration-200 hover:text-nexcyan">
                <Mail size={15} className="text-nexcyan shrink-0" /> {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={15} className="text-nexcyan shrink-0 mt-0.5" />
              <span className="break-words">{BRAND.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50" data-testid="footer-copyright">
            © 2026 NexOrbit Solutions LLP. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            <a href="/admin" className="hover:text-nexcyan transition-colors" data-testid="footer-admin-link">Admin Login</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
